import React, { useState, useContext, useEffect } from 'react'
import ProductFieldsView from '@/custom/components/organisms/Product/FieldsView'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import * as Yup from 'yup'
import SettingContext from '@/product/context/setting/settingContext'
import Layout from '@/product/components/templates/Layout'
import { useHistory } from 'react-router-dom'
import CustomCommonContext from '@/custom/context/common/commonContext'

import settingContext from '@/custom/context/setting/settingContext'
import UserContext from '@/product/context/user/userContext'
import ProductCommonContext from '@/product/context/common/commonContext'

const AddDynamicListing = (props) => {
    const dynamicContext = useContext(DynamicContext)
    const { project_dynamicfields } = dynamicContext
    const customCommonContext = useContext(CustomCommonContext)
    const { allCountries, allStates, allCities } =
        useContext(ProductCommonContext)

    const settingContexts = useContext(settingContext)
    const settingcontext = useContext(SettingContext)

    const {
        all_users,
        getAllUsers,
        responseStatus: responseStatusUser,
        clearResponse: clearResponseUser,
    } = useContext(UserContext)

    const { getAllGlobalData, all_global_data } = settingContexts

    const history = useHistory()

    // const [updatedValues, setUpdatedValues] = useState({})

    const [inisitalValue, setInisitialValue] = useState()

    const {
        alldata_all_dropdown,
        getGlobalVariable,
        allConfigurationVariables,
    } = customCommonContext
    const [data, setData] = useState({
        popup: false,
        status: 'new',
        id: 0,
        projectType: 0,
    })

    useEffect(() => {
        getAllGlobalData()
        getAllUsers({
            filters: {
                action: {
                    value: 'active',
                    type: 'in',
                    field: 'u.status',
                },
                admin: {
                    value: '1',
                    type: 'in',
                    field: 'u.admin',
                },
            },
        })
    }, [])

    const {
        searchTableAction,
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext

    const optionFunc = (data) => {
        searchTableFetch(
            {
                page: 1,
                limit: 25,
                order: '',
                orderby: '',
                filters: {
                    user_id: {
                        value: data,
                        type: 'like',
                        field: 'e.emp_firstname,e.emp_lastname,e.username,e.id,e.emp_email',
                    },
                },
                primaryTable: 'employees',
            },
            'employees'
        )
    }
    const custom = {
        user_id: '',
        first_name: '',
        last_name: '',
        email: '',
        auction: 1,
    }

    useEffect(() => {
        if (alldata_all_dropdown) {
            let val = alldata_all_dropdown.filter(
                (item) => item.variable == 'listing_type'
            )
            setInisitialValue(val[0]?.id)
        }
    }, [alldata_all_dropdown])

    const [fieldValue, setFieldValue] = useState([])

    useEffect(() => {
        if (project_dynamicfields && project_dynamicfields.length) {
            let projectDynamicArray = [...project_dynamicfields]
            let dynamicValueAssign = []
            let projectType = ''
            projectDynamicArray
                .filter((data) => data.active === 1)
                .map((item) => {
                    if (item.view_on && projectType) {
                        if (
                            item.view_on.includes(projectType) ||
                            item.view_on.includes('10')
                        ) {
                            if (item.name === 'qty') {
                                item.initialDefault = 1
                            } else if (item.name === 'sprice') {
                                item.initialDefault = 1
                            } else if (item.type == 'uploadDropZone') {
                                item.isCrop = true
                                item.reorder = true
                            } else if (item.name == 'cigar_source') {
                                item.diff_value = 1
                                item.options =
                                    all_global_data?.cigar_source?.length > 0
                                        ? all_global_data.cigar_source?.map(
                                              (value) => ({
                                                  description:
                                                      value.source_value,
                                                  show: value.source_value,
                                                  value: value.source_value,
                                              })
                                          )
                                        : []
                            } else if (item.name == 'maker') {
                                if (all_global_data?.records.length > 0) {
                                    // Step 1: Extract unique makers using a Set to avoid duplicates
                                    const uniqueMakers = [
                                        ...new Set(
                                            all_global_data.records.map(
                                                (record) => record.Maker
                                            )
                                        ),
                                    ]

                                    // Step 2: Map each unique maker to the required structure
                                    item.options = uniqueMakers.map(
                                        (maker) => ({
                                            description: maker,
                                            show: maker,
                                            value: maker,
                                        })
                                    )

                                    // Step 3: Filter the unique makers for those that contain "Habanos" (case-insensitive)
                                    const filteredData = uniqueMakers.filter(
                                        (maker) => /Habanos/i.test(maker)
                                    )

                                    // Step 4: Set the initialDefault if there's a match in the filteredData
                                    if (filteredData.length > 0) {
                                        item.initialDefault = filteredData[0] // Take the first matching value
                                    }
                                }
                            } else if (item.name == 'maker_country') {
                                item.initialDefault = 'Cuba '
                            } else if (item.name == 'cigar_country') {
                                item.initialDefault = 'Cuba'
                            } else if (item.name == 'delivery_not_available') {
                                item.diff_value = 1
                                item.class = 'd-none'
                            } else if (
                                item.name == 'delivery_available_country'
                            ) {
                                item.diff_value = 1
                                item.class = 'd-none'
                                // let countrySelectedAll = allCountries.map(
                                //     (country) => country.isoCode
                                // )
                                // item.initialDefault = countrySelectedAll
                            } else if (item.name == 'item') {
                                if (alldata_all_dropdown) {
                                    let val = alldata_all_dropdown.filter(
                                        (item) => item.variable == 'item'
                                    )

                                    item.initialDefault = val[0]?.id
                                }
                            } else if (item.name == 'user_id') {
                                item.type = 'searchdrop'
                                item.style = { height: 30 }
                                item.getAllOptions = optionFunc
                                item.options = []
                                item.forcePopupIcon = false
                                item.focused = true
                            }

                            dynamicValueAssign.push(item)
                        }
                    } else {
                        if (item.name === 'qty') {
                            item.initialDefault = 1
                        } else if (item.name === 'sprice') {
                            item.initialDefault = 1
                        } else if (item.type == 'uploadDropZone') {
                            item.isCrop = true
                        } else if (item.name == 'maker') {
                            if (all_global_data?.records.length > 0) {
                                // Step 1: Extract unique makers using a Set to avoid duplicates
                                const uniqueMakers = [
                                    ...new Set(
                                        all_global_data.records.map(
                                            (record) => record.Maker
                                        )
                                    ),
                                ]

                                // Step 2: Map each unique maker to the required structure
                                item.options = uniqueMakers.map((maker) => ({
                                    description: maker,
                                    show: maker,
                                    value: maker,
                                }))

                                // Step 3: Filter the unique makers for those that contain "Habanos" (case-insensitive)
                                const filteredData = uniqueMakers.filter(
                                    (maker) => /Habanos/i.test(maker)
                                )

                                // Step 4: Set the initialDefault if there's a match in the filteredData
                                if (filteredData.length > 0) {
                                    item.initialDefault = filteredData[0] // Take the first matching value
                                }
                            }
                        } else if (item.name == 'item') {
                            if (alldata_all_dropdown) {
                                let val = alldata_all_dropdown.filter(
                                    (item) => item.variable == 'item'
                                )

                                item.initialDefault = val[0]?.id
                            }
                        } else if (item.name == 'source_location') {
                            item.options = allCountries
                                .filter((country) => country?.isoCode !== 'EU') // Assuming 'currency' field indicates EU
                                .map((country) => ({
                                    show: country.name,
                                    value: country.isoCode,
                                }))
                            item.country = false
                        } else if (item.name == 'storage_location') {
                            item.options = allCountries
                                .filter((country) => country?.isoCode !== 'EU') // Assuming 'currency' field indicates EU
                                .map((country) => ({
                                    show: country.name,
                                    value: country.isoCode,
                                }))
                            item.country = false
                        } else if (item.name == 'maker_country') {
                            item.initialDefault = 'Cuba'
                        } else if (item.name == 'cigar_country') {
                            item.initialDefault = 'Cuba'
                        } else if (item.name == 'cigar_source') {
                            item.diff_value = 1
                            item.options =
                                all_global_data?.cigar_source?.length > 0
                                    ? all_global_data.cigar_source?.map(
                                          (value) => ({
                                              description: value.source_value,
                                              show: value.source_value,
                                              value: value.source_value,
                                          })
                                      )
                                    : []
                        } else if (item.name == 'standard_delivery_included') {
                            if (alldata_all_dropdown) {
                                let val = alldata_all_dropdown.filter(
                                    (item) =>
                                        item.variable ==
                                            'standard_delivery_included' &&
                                        item.description == 'No'
                                )

                                item.initialDefault = val[0]?.id
                            }
                        } else if (item.name == 'delivery_to') {
                            if (alldata_all_dropdown) {
                                let val = alldata_all_dropdown.filter(
                                    (item) =>
                                        item.variable == 'delivery_to' &&
                                        item.description == 'All'
                                )

                                item.initialDefault = val[0]?.id
                            }
                        } else if (item.name == 'delivery_not_available') {
                            item.diff_value = 1
                            item.class = 'd-none'
                        } else if (item.name == 'delivery_available_country') {
                            item.diff_value = 1
                            item.class = 'd-none'
                            // let countrySelectedAll = allCountries.map(
                            //     (country) => country.isoCode
                            // )
                            // item.initialDefault = countrySelectedAll
                        } else if (item.name === 'reason_for_price_required') {
                            item.class = 'd-none'
                        } else if (item.name == 'user_id') {
                            item.type = 'searchdrop'
                            item.style = { height: 30 }
                            item.getAllOptions = optionFunc
                            item.options = []
                            item.forcePopupIcon = false
                            item.focused = true
                        }

                        dynamicValueAssign.push(item)
                    }
                })

            setFieldValue(dynamicValueAssign)
        }
    }, [project_dynamicfields, all_global_data])

    const additionalFieldUpdate = (data) => {
        // setUpdatedValues(data)
    }
    const closeFunction = () => {
        history.goBack()
    }
    return (
        <>
            <>
                <Layout>
                    <ProductFieldsView
                        fieldValue={fieldValue}
                        userId={props.userId}
                        data={data}
                        showasin={false}
                        homeDepot={false}
                        initialId={inisitalValue}
                        function={props.function}
                        asinMapData={[]}
                        homeMapData={[]}
                        noUpdateBtn={false}
                        additionalFieldUpdate={additionalFieldUpdate}
                        closeFunction={closeFunction}
                        customFilter={props.customFilter}
                        customInitialValues={custom}
                        standalone={
                            global.standalone ? global.standalone : false
                        }
                    />
                </Layout>
            </>
        </>
    )
}

export default AddDynamicListing
